const accountList = {
  bindings: {
    allAccounts: '<',
    userGroups: '<'
  },
  templateUrl: '/modules/users/account-list/account-list.html',
  controller: 'AccountListController',
};

angular
  .module('users.module')
  .component('accountList', accountList);
